import {useEffect, useState} from 'react';
import {ParisFactory} from '@baidu/paris';

export interface Paris {
    getAcsInstance: (error: Error, acsInstance: AcsInstance) => void;
    getAbcliteInstance: (error: Error, acsInstance: AbcliteInstance) => void;
    getAbcliteAutoResponse: () => Promise<void>;
}

export interface AcsInstance {
    getSign(callback: (error: Error, sign: string) => void, extraData?: string): void;
}

export interface AbcliteInstance {
    getAutoResponse(callback: (error: Error, siresponsegn: string) => void): void;
    getActiveResponse(
        params: {
            subid: () => void;
        },
        callback: (error: Error, siresponsegn: string) => void
    ): void;
}

const sid = 2109;

/**
 * 玉门关sdk接入
 * @returns [错误信息，鉴权touken，实例]
 * @see https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/pKzJfZczuc/cuv64FB8Ez/eq4KoU5lPxs_OL
 */
function useParis() {
    const [instance, setInstance] = useState<Paris>();
    const [acsToken, setAcsToken] = useState('');
    const [errorInfo, setErrorInfo] = useState<Error | undefined>();
    useEffect(
        () => {
            ParisFactory.create({
                sid: sid,
                timeout: 5000, // CDN的请求超时时间
                abcliteUrl: `https://dlswbr.baidu.com/heicha/mw/abclite-${sid}-s.js`,
                acsUrl: `https://dlswbr.baidu.com/heicha/mm/${sid}/acs-${sid}.js`,
                // 容灾配置
                disasterConfig: {
                    // 备用CDN地址
                    acsUrl: `https://miaowu.baidu.com/sdk/heicha/mm/${sid}/acs-${sid}.js`,
                    abcliteUrl: `https://miaowu.baidu.com/sdk/heicha/mw/abclite-${sid}-s.js`,
                    secondReportUrl: 'https://miaowu.baidu.com/slim/abdr',
                },
            });

            const instance = (window as any)[`paris_${sid}`];

            /**
             * 获取token
             */
            instance.getAcsInstance((error: Error, acsInstance: AcsInstance) => {

                if (error) {
                    console.error(error);
                    setErrorInfo(error);
                    return;
                }

                acsInstance.getSign((error, sign) => {
                    if (error) {
                        console.error(error);
                        setErrorInfo(error);
                        return;
                    }
                    setAcsToken(sign);
                });
            });

            instance.getAbcliteAutoResponse = () => new Promise((rel, rej) => {
                try {
                    /**
                     * 反爬
                     */
                    instance.getAbcliteInstance((error: Error, abcliteInstance: AbcliteInstance) => {
                        if (error) {
                            rej(error);
                            return;
                        }
                        abcliteInstance.getActiveResponse(
                            {
                                subid: () => 'vote',
                            },
                            (error, response) => {
                                if (error) {
                                    rej(error);
                                }
                                rel(response);
                                // response 暂不处理
                            }
                        );
                    });
                } catch (error) {
                    rej(error);
                }
            });

            setInstance(instance);
        },
        []
    );
    return [
        errorInfo,
        acsToken,
        instance,
    ] as [Error | undefined, string, Paris];
}

export default useParis;
